export const DARK = "DARK";
export const LIGHT = "LIGHT";
